import { observable } from '@nx-js/observer-util';
import Fragment from '../../Fragment';
import WipLimit from '../WipLimit';
import type ApplicationModel from 'components/framework/ApplicationModel';

export interface HasWipLimits {
  setWipLimit(workflowStatusId: string, limit: number): void;
  removeWipLimit(workflowStatusId: string): void;
  saveWipLimits(): Promise<void>;
  wipLimitsForQuery(
    value: any[]
  ): { workflowStatusId: string; limit: number }[];
}

function HasWipLimits(originalClass: {
  new (...args: any[]): ApplicationModel & {
    id: string;
    wipLimits: WipLimit[];
  };
}): any {
  return class extends originalClass implements HasWipLimits {
    setWipLimit(workflowStatusId, limit) {
      const { wipLimits } = this;
      const wipLimit = wipLimits.find(
        wipLimit => wipLimit.workflowStatusId === workflowStatusId
      );

      if (wipLimit) {
        wipLimit.limit = limit;
      } else {
        // @ts-ignore pushing wrong object type into array
        wipLimits.push(observable({ workflowStatusId, limit }));
      }
    }

    removeWipLimit(workflowStatusId) {
      const { wipLimits } = this;
      const wipLimitIndex = wipLimits.findIndex(
        wipLimit => wipLimit.workflowStatusId === workflowStatusId
      );

      if (wipLimitIndex > -1) {
        wipLimits.splice(wipLimitIndex, 1);
      }
    }

    async saveWipLimits() {
      const { id, wipLimits } = this;

      const fragment = new Fragment('setWipLimits')
        .argument('id', id)
        .argument(
          'wipLimits',
          wipLimits.map(wipLimit => ({
            workflowStatusId: wipLimit.workflowStatusId,
            limit: wipLimit.limit,
          })),
          '[WipLimitInput!]!'
        )
        .fragment(
          WipLimit.select('workflowStatusId', 'limit')
            .first()
            .buildQueryFragment('wipLimits')
        );

      await WipLimit.mutate(fragment);
    }

    wipLimitsForQuery(value) {
      return value.map(wipLimit => ({
        workflowStatusId: wipLimit.workflowStatusId,
        limit: wipLimit.limit,
      }));
    }
  };
}

export { HasWipLimits };
